CW = window.CW || {};


CW.basket.regBasketUpdateEvent('header', function (res) {
    var $headerItemCart = $('.icon-header-item.cart');
    var $headerItemFavorite = $('.icon-header-item.favorite');

    var fovarCount  = $headerItemFavorite.find('.count');
    var basketCount = $headerItemCart.find('.count');

    if(res.DELAY_PRODUCT.length > 0){
        if(!$headerItemFavorite.hasClass('active')){
           $headerItemFavorite.addClass('active');
        }
        if(fovarCount.hasClass('hide')){
           fovarCount.removeClass('hide');
           fovarCount.addClass('show');
        }
        fovarCount.text((res.DELAY_PRODUCT.length > 9) ? '9+' : res.DELAY_PRODUCT.length);
    }else{
        if($headerItemFavorite.hasClass('active')){
           $headerItemFavorite.removeClass('active');
        }
        if(fovarCount.hasClass('show')){
           fovarCount.removeClass('show');
           fovarCount.addClass('hide');
        }
    }
    if (res.COUNT > 0) {
        if (!$headerItemCart.hasClass('active')) {
            $headerItemCart.addClass('active');
        }

        if (basketCount.hasClass('hide')) {
            basketCount.removeClass('hide');
            basketCount.addClass('show');
        }
        basketCount.text((res.COUNT > 9) ? '9+' : res.COUNT);
    } else {
        if ($headerItemCart.hasClass('active')) {
            $headerItemCart.removeClass('active');
        }

        if (basketCount.hasClass('show')) {
            basketCount.removeClass('show');
            basketCount.addClass('hide');
        }
    }

    $headerItemCart.find('.header-menu-text').text(CW.price(res.SUMM, true));
});


$(function () {

    //работа кнопки вверх
    const screenHeight = $(window).height();
    const button = $(".scroll-top-btn");
    let buttonHeight = button.outerHeight();
    let documentHeight = $(document).height();

    $(window).scroll(function () {

        if ($(window).width() >= 1024) {
            let scrollPosition = $(window).scrollTop();
            let remainingSpace = documentHeight - scrollPosition - screenHeight + buttonHeight;

            if ($(window).scrollTop() > 100) {
                $(button).addClass('active'); // Показ кнопки
            } else {
                $(button).removeClass('active'); // Скрытие кнопки
            }

            //чтобы кнопка "вверх" не опускалась ниже 280px
            if (remainingSpace < 280) {
                button.css("bottom", 280 + "px");
            } else {
                button.css("bottom", "130px");
            }
        }

        //фиксируем header
        if ($(window).scrollTop() > 10) {
            $('header').addClass('fixed-header');
        } else {
            $('header').removeClass('fixed-header');
        }

    });


    // Плавный скролл вверх
    $('.scroll-top-btn').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });

    //фиксируем header при загрузке, если скролл больше 0
    $(document).ready(function () {
        if ($(window).scrollTop() > 0) {
            $('header').addClass('fixed-header');
        } else {
            $('header').removeClass('fixed-header');
        }
    });

    //------- popup -------

    //если popup при загрузке
    $(document).ready(function () {
        if ($('.site-popup').hasClass('opened')) {
            $('body').addClass('fixed-body');
            $('.overflow-body').addClass('show-open-popup');
        }
    });

    //popup выбора города
    $('body').on('click', '.location-href', function () {
        $('.site-popup.city-popup').addClass('opened');
        $('body').addClass('fixed-body');
        $('.overflow-body').addClass('show-open-popup');
        $('.city-popup .bx-ui-sls-fake').focus();
    });


    // после отправки заявки на подписку - открытие попапа

    function openResultPopup(msg, status, email) {

        const $modal = $('.site-popup.mailing-popup');
        $modal.addClass('opened');
        $('body').addClass('fixed-body');
        $('.overflow-body').addClass('show-open-popup');

        const $contents = $modal.find('.js-content');

        $contents.each(function(i, item){
            $(item).addClass('hidden');
        })

        if(status) {
            if (!CW.getCookie("BITRIX_SM_SUBSCRIBE_FORM")) {
                var date = new Date;
                date.setDate(date.getDate() + 2);
                CW.setCookie("BITRIX_SM_SUBSCRIBE_FORM", "true", date.toUTCString(), '/');
            }
            $modal.find('.js-success-content').removeClass('hidden');
            const userEmailEem = $modal.find('.js-user-email');
            const userEmail = email ? email : '';
            userEmailEem.text(userEmail);
        } else {
            const message = msg ? msg : 'Ошибка';
            $modal.find('.js-error-content').removeClass('hidden').html(`<div class="error-message">${message}</div>`);
        }

        return false

    }


    $('#cw-subscribe').on('focus', '.js-email-input', function() {
        const $this = $(this);
        const errorMsg = $this.closest('.js-input-label').find('.js-error-msg');
        errorMsg.text('').addClass('hidden');
    })

    // валидация согласия на обработку перс данных

    function validateAgreement(checkbox) {
        const $checkbox = $(checkbox);
        const errorMsg = $(checkbox).closest('form').find('.js-agreement-error');
        let result = true

        if ($checkbox[0].checked) {
            errorMsg.text('').addClass('hidden');
        } else {
            errorMsg.text('Необходимо согласиться с обработкой персональных данных').removeClass('hidden')
            result = false
        }

        return result
    }

    // валидация email
    function validateEmail(input) {
        const LATIN_EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
        const inputValue = input.val();
        const errorElem = input.closest('.js-input-label').find('.js-error-msg');
        errorElem.text('').addClass('hidden');
        const result = LATIN_EMAIL_REGEXP.test(inputValue);

        if(!result) {
            errorElem.removeClass('hidden')
            errorElem.text('Поле E-mail необходимо заполнить');
        }

        return result
    }

    // оформить подписку
    $(document).on('submit', '.subscription-form', function (e) {

        e.preventDefault();
        var $form = $(this),
            formData = $form.serialize();
        var emailInput = $form.find('.js-email-input');
        var checkbox = $form.find('#customCheckbox');
        var email = emailInput.val();

        // поле токена, который передан в value
        const captchaInput = $form.find('.js-smart-captcha-input');
        console.log(formData);
        

        if(validateEmail(emailInput) && validateAgreement(checkbox)) {
            $.ajax({
                global: false,
                type: "POST",
                url: "/ajax/subscribe/",
                data: formData,
                success: function (r) {
                    let msg = r.msg;

                    switch (r.result) {
                        case 'captchaFail':
                            // Ошибка проверки капчи
                            openResultPopup("Проверка не пройдена", false);
    
                            // Сбрасываем капчу (чтобы пройти снова)
                            const widgetId = $form.find('.js-smart-captcha').data('scWidgetId');

                            if (widgetId && window.smartCaptcha) {
                                window.smartCaptcha.reset(widgetId);
                            }
                            break;
                            
                        case 'failEmail':
                            openResultPopup(msg, false, email);
                            emailInput.val('');
                            break;
                        case 'error':
                            openResultPopup(msg, false);
                            emailInput.val('');
                            break;
                        case 'ok':
                            openResultPopup(msg, true, email);
                            emailInput.val('');
                            break;

                        default:
                            console.log('Системная ошибка.');
                            break;
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Form submit error:', status, error);
                    throw new Error('Form submit error: ' + status + ' - ' + error);
                }
            });
        } else {
            console.log('поля не прошлии валидацию')
        }
    })

    //popup написать директору
    $('.btn-director-popup').on('click', function (e) {
        e.preventDefault();
        $('.site-popup.director-popup').addClass('opened');
        $('body').addClass('fixed-body');
        $('.overflow-body').addClass('show-open-popup');

        if ($('.js-director-popup').find('.custom-checkbox').length) {
            $('.js-submit-btn').attr('disabled', true);
        }

        return false;
    });

    $('.btn-order-cancellation-popup').on('click', function (e) {
        e.preventDefault();
        const orderId = $(this).data('order-id');
        $('.js-order-cancel-btn').attr('data-order-id', orderId);
        $('.order-cancellation-popup').addClass('opened');
        $('body').addClass('fixed-body');
        $('.overflow-body').addClass('show-open-popup');
        return false;
    });

    //popup оставить заявку
    $('.btn-application-popup').on('click', function (e) {
        e.preventDefault();
        $('.site-popup.js-application-popup').addClass('opened');
        $('body').addClass('fixed-body');
        $('.overflow-body').addClass('show-open-popup');

        if ($('.site-popup.js-application-popup').find('.custom-checkbox').length) {
            $('.js-submit-btn').attr('disabled', true);
        }

        return false;
    });

    //popup заказать консультацию
    $('.contacts-page .btn-complaint').on('click', function () {
        $('.site-popup.complaint-popup').addClass('opened');
        $('body').addClass('fixed-body');
        $('.overflow-body').addClass('show-open-popup');
    });

    //закрыть меню и пупапы по клику на close в пупапах
    $('.site-popup .close-button').on('click', function (e) {

        $('.overflow-body').removeClass('show-open-popup');
        $(this).closest('.site-popup').removeClass('opened');
        $('body').removeClass('fixed-body');
    });

    $('.site-popup .js-close-button').on('click', function (e) {

        $('.overflow-body').removeClass('show-open-popup');
        $(this).closest('.site-popup').removeClass('opened');
        $('body').removeClass('fixed-body');
    });


    //закрыть все пупапы по клавише esc
    $(document).on('keydown', function (event) {
        if (event.which == 27) {
            $('.overflow-body').removeClass('show-open-popup');
            $('.site-popup').removeClass('opened');
            $('body').removeClass('fixed-body');
            $('.shadow-bg').hide();
        }
    });

    //закрыть все пупапы по клику на фон .shadow-bg
    $(document).on('click', '.shadow-bg', function (e) {
        // Проверяем, что клик был именно на фон, а не на дочерний элемент
        if ($(e.target).is('.shadow-bg')) {
            $('.overflow-body').removeClass('show-open-popup');
            $('.site-popup').removeClass('opened');
            $('body').removeClass('fixed-body');
            $('.shadow-bg').fadeOut(300);
        }
    });

    //------- Поиск -------

    $('.search-form').on('submit', function (e) {
        let $this = $(this);
        let $input = $this.find('input');
        let search = encodeURI($input.val().replace(/["«»:?%]/g, '').toLowerCase());

        if(search === '' || $input.val().replace(/\s/g, '') === '')
        {
            return false;
        }
        search = search.replace(/\//g, "_slash_");
        location.href = $this.attr('action') + search + '/';
        e.preventDefault();
        return false;
    });

    let quickSearchRequest = false;

    //show/hide для close у поиска
    $('.search-form .input-search').on('input', function () {
        let $parent = $(this).closest('.search-form ');
        let val = $(this).val();
        let $closeBtn = $parent.find('.search-clear');

        let quickSearchBlock = $('.search-form .js-quick-search');
        let quickSearchResult = quickSearchBlock.find('.items');

        if (val != '') {
            $closeBtn.show();

            if(val.length >= 3 && !quickSearchRequest)
            {

                quickSearchRequest = true;
                quickSearchBlock.hide();
                quickSearchResult.find('.item').remove();

                $.post(
                    '/local/tools/ajax/quick-search.php',
                    {
                        query: val,
                    },
                    function(response)
                    {
                        if(response['items'] !== undefined && response['items'].length > 0)
                        {

                            $.each(
                                response['items'],
                                function(i, item)
                                {

                                    // заменяем в подсказках в строках-ссылках на результат поиска  все слэши  на _slash_ кроме /search/ и слэша в конце строки
                                    const parts = item['url'].split(/\/search\//, 2);
                                    const searchPart = parts[0] + "/search/";
                                    const remainingPart = parts[1];
                                    const itemUrl = searchPart + remainingPart.replace(/\/(?!$)/g, "_slash_");
                                    console.log('itemUrl', itemUrl)

                                    if(item['query'] !== undefined && item['query'].length > 0)
                                    {
                                        quickSearchResult.append(
                                            $('<div />')
                                                .addClass('item')
                                                .append(
                                                    $('<a />')
                                                        .attr('href', itemUrl)
                                                        .text(item['query'])
                                                )
                                        );
                                    }
                                }
                            );

                            if(quickSearchResult.find('.item').length > 0)
                            {
                                quickSearchBlock.show();
                            }
                        }

                        quickSearchRequest = false;
                    },
                    'json'
                )
            }
        } else {
            quickSearchBlock.hide();
            quickSearchResult.find('.item').remove();
            $closeBtn.hide();
        }
    });

    //стереть все по клику на search-clear
    $('.search-form .search-clear').on('click', function () {
        let $parent = $(this).closest('.search-form ');
        let $input = $parent.find('.input-search');

        let quickSearchBlock = $('.search-form .js-quick-search');
        let quickSearchResult = quickSearchBlock.find('.items');

        quickSearchBlock.hide();
        quickSearchResult.find('.item').remove();

        $input.val('');
        $(this).hide();
        $parent.find('.input-text-row').removeClass('input-filled');
    });

    var $directorForm = $('#director-form').submit(function (e) {
        e.preventDefault();
    
        var $form = $(this),
            formData = $form.serialize(); // больше не нужен массив
    
        $.ajax({
            url: '/ajax/director/',
            type: "POST",
            data: formData,
            success: function (json) {
                if (json.success) {
                    $directorForm.find('.form-wr').html(
                        '<div style="font-size: 2em;color: #41ead4;">' + json.success + '</div>'
                    );
                } else {
    
                    if (json['error'] !== undefined) {
                        let errorMessage = '';
    
                        $.each(json['error'], function(key, message) {
                            errorMessage += message + '<br>';
                        });
    
                        $("#alert_popup").html(errorMessage);
                        $(".site-popup.alert-popup").addClass('opened');
                    }
                }
            },
            error: function(xhr, status, error) {
                console.error('Director form error:', status, error);
                throw new Error('Director form error: ' + status + ' - ' + error);
            }
        });
    
        return false;
    });

    $('.js-terms-of-use').click(
        function(e)
        {

            $(".site-popup.footer-terms-of-use").addClass('opened');
            $('.shadow-bg').fadeIn(300);
            e.preventDefault();
        }
    );

    $('.footer-row.menu .footer-menu-item .block-title').click(
        function()
        {
            if($(window).width() <= 575)
            {

                if($(this).hasClass('active'))
                {
                    $(this).removeClass('active');
                    $(this).parent().find('.menu-items').slideUp();
                    return;
                }

                $('.footer-row.menu .footer-menu-item .block-title').removeClass('active');
                $('.footer-contact-block .block-title').removeClass('active');
                $(this).addClass('active');

                $('.footer-row.menu .footer-menu-item .menu-items').slideUp();
                $('.footer-contact-block .display-block').slideUp();

                $(this).parent().find('.menu-items').slideDown();
            }
        }
    );

    $('.footer-contact-block .block-title').click(
        function()
        {
            if($(window).width() <= 575)
            {

                if($(this).hasClass('active'))
                {

                    $(this).removeClass('active');
                    $('.footer-contact-block .display-block').slideUp();
                    return;
                }

                $('.footer-row.menu .footer-menu-item .block-title').removeClass('active');
                $('.footer-contact-block .block-title').removeClass('active');
                $('.footer-row.menu .footer-menu-item .menu-items').slideUp();

                $(this).addClass('active');
                $(this).parent().find('.display-block').slideToggle();
            }
        }
    );

    //слушатель чекбокса согласия на обработку персональных данных popup оставить заявку
    $(document).on('change', '.js-application-popup .js-custom-checkbox input, .js-application-popup .js-smart-captcha-input', function () {
        const $popup = $(this).closest('.js-application-popup');
        const $submitBtn = $popup.find('.js-submit-btn');

        const isCustomChecked = $popup.find('.js-custom-checkbox input').is(':checked');
        const isCaptchaChecked = $popup.find('.js-smart-captcha-input').is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });

    //слушатель чекбокса согласия на обработку персональных данных popup написать директору
    $(document).on('change', '.js-director-popup .js-custom-checkbox input, .js-director-popup .js-smart-captcha-input', function () {
        const $popup = $(this).closest('.js-director-popup');
        const $submitBtn = $popup.find('.js-submit-btn');

        const isCustomChecked = $popup.find('.js-custom-checkbox input').is(':checked');
        const isCaptchaChecked = $popup.find('.js-smart-captcha-input').is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });



    //слушатель чекбокса согласия на обработку персональных данных в форме страницы отзывы
    $(document).on('change', '.js-reviews-form .js-custom-checkbox input, .js-reviews-form .js-smart-captcha-input', function () {
        const $form = $(this).closest('.js-reviews-form');
        const $submitBtn = $form.find('.js-submit-btn');

        const isCustomChecked = $form.find('.js-custom-checkbox input').is(':checked');
        const isCaptchaChecked = $form.find('.js-smart-captcha-input').is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });

    //слушатель чекбокса согласия на обработку персональных данных popup оставить отзыв
    $(document).on('change', '.js-review-popup .js-custom-checkbox input, .js-review-popup .js-smart-captcha-input', function () {
        const $popup = $(this).closest('.js-review-popup');
        const $submitBtn = $popup.find('.js-submit-btn');

        const isCustomChecked = $popup.find('.js-custom-checkbox input').is(':checked');
        const isCaptchaChecked = $popup.find('.js-smart-captcha-input').is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });



    //слушатель чекбокса согласия на обработку персональных данных регистрация
    $(document).on('change', '.js-register-form .js-custom-checkbox input, .js-register-form .js-smart-captcha-input', function () {
        const $form = $(this).closest('.js-register-form');
        const $submitBtn = $form.find('.js-register-btn');

        const isCustomChecked = $form.find('.js-custom-checkbox input').is(':checked');
        const isCaptchaChecked = $form.find('.js-smart-captcha-input').is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });

    //слушатель чекбокса согласия на обработку персональных данных востановление пароля
    $(document).on('change', '.bxmodAuthRestore .js-smart-captcha-input', function () {
        const $form = $(this).closest('.bxmodAuthRestore');
        const $submitBtn = $form.find('.bxmodAuthRestoreButton');

        const isCaptchaChecked = $(this).is(':checked');

        $submitBtn.attr('disabled', !isCaptchaChecked);
    });

    //слушатель чекбокса согласия на обработку персональных данных авторизация
    $(document).on('change', '.bxmodAuthLogin .js-smart-captcha-input', function () {
        const $form = $(this).closest('.bxmodAuthLogin');
        const $submitBtn = $form.find('.bxmodAuthLoginButton');

        const isCaptchaChecked = $(this).is(':checked');

        $submitBtn.attr('disabled', !isCaptchaChecked);
    });

    //слушатель чекбокса согласия на обработку персональных данных дроппшипинг
    $(document).on('change', '.js-dropshipping-form .js-custom-checkbox input, .js-dropshipping-form .js-smart-captcha-input', function () {
        const $form = $(this).closest('.js-dropshipping-form');
        const $submitBtn = $form.find('.js-dropshipping-submit-btn');

        const isCustomChecked = $form.find('.js-custom-checkbox input').is(':checked');
        const isCaptchaChecked = $form.find('.js-smart-captcha-input').is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });

    //слушатель чекбокса согласия на обработку персональных данных подписка
    $(document).on('change', '.js-subscription-form #customCheckbox, .js-subscription-form .js-smart-captcha-input', function () {
        const $form = $(this).closest('.js-subscription-form');
        const $submitBtn = $form.find('.js-subscription-submit-btn');

        const isCustomChecked = $form.find('#customCheckbox').is(':checked');
        const isCaptchaChecked = $form.find('.js-smart-captcha-input').is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });

    $(document).on('change', '.js-subscription-form .js-smart-captcha-input', function () {
        const $form = $(this).closest('.js-subscription-form');
        const $submitBtn = $form.find('.js-subscription-submit-btn');

        const isCustomChecked = $form.find('#customCheckbox').is(':checked');
        const isCaptchaChecked = $(this).is(':checked');

        $submitBtn.attr('disabled', !(isCustomChecked && isCaptchaChecked));
    });
});
